import React, { useState } from 'react';
import styled from 'styled-components';
import { Layout, Modal} from 'antd';
const { Content } = Layout;
import { Route, Router, Switch } from 'react-router-dom';
import { history, RoutePaths } from 'core/history';
import { PageNotFound } from 'pages/page-not-found';
import { OverviewPage } from 'pages/Overview';
import { ProfilePage } from 'pages/Profile';
import { MembersPage } from 'pages/Members';
import { ProductsPage } from 'pages/Products';
import { WorkspaceSidebar  } from 'components/SIdebar/Sidebar';
import './index.less'
import sideBarIcon from '../../assets/icons/menu_24px.png'
import { getBrandLogo } from '../../utils/BrandingUtils';
import { useMediaQuery } from 'react-responsive';

const StyledLayout = styled(Layout)`
  height: 100%;
  min-height: 90%;
`;

const StyledContent = styled(Content)`
  background-color: #eff1f5;
  overflow-y: ${() => {
        if (window.location.href.includes('deep-actions')) {
            return 'hidden';
        }
        return 'auto';
    }};
  overflow-x: auto;
  position: relative;
  /* //keeping below padding commented in case if we need in future */
  /* padding: 10px; */
  .ant-layout {
    background-color: #eff1f5;
  }
`;
function renderComponent(Component : any, p : any) {
  sessionStorage.setItem('pageIdentifierKey', p.pageIdentifierKey || '');
  return <Component {...p} />;
}
const WorkspaceRoutesContainer = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const isMobile = useMediaQuery({ query: '(max-width: 719px)' });
    const showModal = () => {
      setIsModalVisible(true);
    };
  
  
    const handleCancel = () => {
      setIsModalVisible(false);
    };

    const redirectToAccountsPage =  () => {
      history.push({
        pathname: RoutePaths.WORKSPACES(),
        search: location.search,
      });
  
    };

    return (
      <StyledLayout>
        {
          (isMobile) ?
            <>
              <span
                className='customSidebarPng'
                onClick={showModal}
              >
                <img src={sideBarIcon} />
              </span>
              <Modal
                forceRender
                title={
                  <span onClick={() => { redirectToAccountsPage() }}>
                    <img style={{height:'70px'}} src={getBrandLogo()}></img>
                  </span>
                } 
                visible={isModalVisible} 
                okButtonProps={{ style: { display: "none" } }}
                cancelButtonProps={{ style: { display: "none" } }} 
                onCancel={handleCancel} 
                className="customSidebarModal"
              >
                <WorkspaceSidebar {...{handleCancel}}/>
              </Modal>
            </> :
            <WorkspaceSidebar />
        }
        <StyledLayout>
          <StyledContent >
            <Router history={history}>
              <Switch>

                <Route path='/' exact={true} render={(p) => renderComponent(OverviewPage, { ...p, pageIdentifierKey: 'overview'})} />
                <Route path={RoutePaths.WORKSPACES()} exact={true} render={(p) => renderComponent(OverviewPage, { ...p, pageIdentifierKey: 'overview'})} />
                <Route path={RoutePaths.PROFILE()} exact={true} render={(p) => renderComponent(ProfilePage, { ...p, pageIdentifierKey: 'profile'})} /> 
                <Route path={RoutePaths.MEMBERS()} exact={true} render={(p) => renderComponent(MembersPage, { ...p, pageIdentifierKey: 'member'})} />
                <Route path={RoutePaths.PLANS()} exact={true} render={(p) => renderComponent(ProductsPage, { ...p, pageIdentifierKey: 'plans'})} />
                <Route component={PageNotFound} />
              </Switch>
            </Router>
          </StyledContent>
        </StyledLayout>
      </StyledLayout>
    )
}


export default WorkspaceRoutesContainer;
